import { render, staticRenderFns } from "./ConsultantBilling.vue?vue&type=template&id=53a4adff&scoped=true&"
import script from "./ConsultantBilling.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConsultantBilling.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConsultantBilling.vue?vue&type=style&index=0&id=53a4adff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4adff",
  null
  
)

export default component.exports